import { Component, Input, OnInit } from "@angular/core";
import { UiService } from "app/helper-components/UiService";
import { PostService } from "app/helpers/post.service";
import { UserDataService } from "app/helpers/user-data.service";
import { environment } from "environments/environment";

@Component({
  selector: "app-alerts-notification",
  templateUrl: "./alerts-notification.component.html",
  styleUrls: ["./alerts-notification.component.scss"],
})
export class AlertsNotificationComponent implements OnInit {
  @Input() currentPage;
  partyPosts = null;
  pages: any;
  alertData: any;
  applyCss: boolean;

  constructor(
    private userDataService: UserDataService,
    private postService: PostService,
    private uiService: UiService
  ) {}

  ngOnInit(): void {
    if (this.currentPage != null) {
      this.fetchAlerts(this.currentPage);
    }
  }

  fetchAlerts(pageNameValue: any) {
    this.uiService.showLoading();
    var postId = [];
    for (
      var i = 0;
      i < this.userDataService.userData.party_posts?.length;
      i++
    ) {
      var postStatus = this.userDataService.userData.party_posts[i].status;
      if (postStatus == 98 || postStatus == 147) {
        postId.push(
          this.userDataService.userData.party_posts[i].party_post_subgroup_id
        );
      }
      this.partyPosts = postId;
    }

    var pageValue = [];
    pageValue.push(pageNameValue);
    this.pages = pageValue;

    const formData = new FormData();
    formData.append("getAlerts", "1");
    formData.append("alert_type", "2");
    if (this.partyPosts != null && pageNameValue == "members") {
      formData.append("party_posts", JSON.stringify(this.partyPosts));
    }
    if (pageNameValue != "members") {
      formData.append("pages", JSON.stringify(this.pages));
    }

    let getAlerts = this.postService.post(environment.API_ALERTS, formData);
    getAlerts.subscribe(
      (val: any) => {
        this.uiService.hideLoading();
        this.alertData = val.data;
        if (this.alertData.length > 1) {
          this.applyCss = true;
        }
      },
      (error) => {}
    );
  }
}
